import Dictionary from './dictionary.vue'

let Plugin = {},
    vueInstance;

Plugin.install = function (Vue, opt) {
    opt.root.dictionary = function () {
        // if (!vueInstance) {
            let el = document.createElement('div')
            document.querySelector('body').appendChild(el)

            let vueClass = Vue.extend(Dictionary);

            vueInstance = new vueClass({
                el: el,
                router: opt.router
            })
        // }

        vueInstance.wrapshow = true
        return vueInstance.showPicker(...arguments)
    }
}


export default Plugin;




